import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'

const gridFiltersConfig: any = {
    STATUSTYPEFILTER: { prop: null, param: 'STATUSTYPEFILTER', url_param: true },
    TEAMFILTER: { prop: null, param: 'TEAMFILTER', url_param: true },
    USERFILTER: { prop: null, param: 'USERFILTER', url_param: true },
    MELDERFILTER: { prop: null, param: 'MELDERFILTER', url_param: true },
    NRBETRFILTER: { prop: null, param: 'NRBETRFILTER', url_param: true },
}

const initialState = {
    loadMeldungListStatus: 'idle',
    loadMeldungListError: undefined as any,
    loadMeldungListLastArgs: undefined as any,
    loadMeldungStatus: 'idle',
    loadMeldungError: undefined as any,
    saveMeldungStatus: 'idle',
    saveMeldungError: undefined as any,
    deleteMeldungenStatus: 'idle',
    deleteMeldungenError: undefined as any,
    loadDefaultMeldPrioStatus: 'idle',
    loadDefaultMeldPrioError: undefined as any,
    loadDefaultMeldStatusStatus: 'idle',
    loadDefaultMeldStatusError: undefined as any,
    loadDefaultMeldungsartStatus: 'idle',
    loadDefaultMeldungsartError: undefined as any,
    setMeldungStatusStatus: 'idle',
    setMeldungStatusError: undefined as any,

    meldungList: [] as any[],
    defaultMeldPrio: undefined as any,
    defaultMeldStatus: undefined as any,
    defaultMeldungsart: undefined as any,
    formItem: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const loadMeldungList = createAsyncThunk('meldungSlice/loadMeldungList', async ({ gridFilters, globalFilters, forceReload }: any, { rejectWithValue, getState }: any) => {
    const lastArgs = getState().meldungSlice.loadMeldungListLastArgs
    if (_.isEqual(lastArgs, { gridFilters, globalFilters }) && !forceReload) { return }

    let promises = []
    {
        const [url, params] = prepParams(`/api/ixweb/nurismeldung/?STATUSTYPE_FILTER=${gridFilters.values.STATUSTYPEFILTER||0}&OBJRANGE_FILTER=${globalFilters.objectFilter||'alle'}&TEAM_FILTER=${gridFilters.lookupValues.TEAMFILTER ? Object.values(gridFilters.lookupValues.TEAMFILTER).map((team: any) => team.HDR_ID) : ''}&USER_FILTER=${gridFilters.lookupValues.USERFILTER ? Object.values(gridFilters.lookupValues.USERFILTER).map((user: any) => user.HDR_ID) : ''}&NRBETREFF_FILTER=${gridFilters.values.NRBETRFILTER||''}&MELDER_FILTER=${gridFilters.values.MELDERFILTER||''}`, globalFilters, gridFilters)
        promises.push(client.get(
            url,
            {
                params,
            }
        ))
    }

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
        args: { gridFilters, globalFilters }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadMeldungListStatus } = getState().meldungSlice
        return loadMeldungListStatus !== 'pending'
    }
})

export const loadMeldung = createAsyncThunk('meldungSlice/loadMeldung', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/nurismeldung/?action=eql&HDR_ID=${id}`,
        prepareData(id),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: value1,
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadMeldungStatus } = getState().meldungSlice
        return loadMeldungStatus !== 'pending'
    }
})

export const saveMeldung = createAsyncThunk('meldungSlice/saveMeldung', async ({ meldung }: any, { rejectWithValue }: any) => {
    let promises = []
    if (meldung?.HDR_ID) {
        promises.push(client.put(
            `/api/ixweb/nurismeldung/${ meldung?.HDR_ID }/`,
            prepareData(meldung),
        ))
    } else {
        promises.push(client.post(
            `/api/ixweb/nurismeldung/`,
            prepareData(meldung),
        ))
    }

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: value1,
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { saveMeldungStatus } = getState().meldungSlice
        return saveMeldungStatus !== 'pending'
    }
})

export const deleteMeldungen = createAsyncThunk('meldungSlice/deleteMeldungen', async ({ selectedIds }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.delete(
        `/api/ixweb/DeleteMeldungen/`,
        prepareData({SELECTEDOBJECTIDS: selectedIds}),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: selectedIds.HDR_ID,
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { deleteMeldungenStatus } = getState().meldungSlice
        return deleteMeldungenStatus !== 'pending'
    }
})

export const loadDefaultMeldPrio = createAsyncThunk('meldungSlice/loadDefaultMeldPrio', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/nurismeldprio/?action=eql&fields=HDR_ID,TAGEBISERLD&DEFAULT=1`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: value1,
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadDefaultMeldPrioStatus } = getState().meldungSlice
        return loadDefaultMeldPrioStatus !== 'pending'
    }
})

export const loadDefaultMeldStatus = createAsyncThunk('meldungSlice/loadDefaultMeldStatus', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/nurismeldstatart/?action=eql&fields=HDR_ID,STATUSTYP&DEFAULT=1&STATUSTYP=1`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: value1,
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadDefaultMeldStatusStatus } = getState().meldungSlice
        return loadDefaultMeldStatusStatus !== 'pending'
    }
})

export const loadDefaultMeldungsart = createAsyncThunk('meldungSlice/loadDefaultMeldungsart', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/nurismeldungsart/?action=eql&fields=HDR_ID&DEFAULT=1`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: value1,
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadDefaultMeldungsartStatus } = getState().meldungSlice
        return loadDefaultMeldungsartStatus !== 'pending'
    }
})

export const setMeldungStatus = createAsyncThunk('meldungSlice/setMeldungStatus', async ({ selectedIds, status }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/ChangeMeldungStatus/`,
        prepareData({SELECTEDOBJECTIDS: selectedIds, STATUSIDTOSET:status}),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: value1,
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { setMeldungStatusStatus } = getState().meldungSlice
        return setMeldungStatusStatus !== 'pending'
    }
})

const MeldungSlice = createSlice({
    name: 'meldungSlice',
    initialState,
    reducers: {
        resetloadMeldungListError: (state) => {
            state.loadMeldungListError = undefined
        },
        resetloadMeldung: (state) => {
            state.formItem = undefined
            state.loadMeldungError = undefined
        },
        resetloadMeldungError: (state) => {
            state.loadMeldungError = undefined
        },
        resetsaveMeldung: (state) => {
            state.formItem = undefined
            state.saveMeldungError = undefined
        },
        resetsaveMeldungError: (state) => {
            state.saveMeldungError = undefined
        },
        resetdeleteMeldungenError: (state) => {
            state.deleteMeldungenError = undefined
        },
        resetloadDefaultMeldPrio: (state) => {
            state.defaultMeldPrio = undefined
            state.loadDefaultMeldPrioError = undefined
        },
        resetloadDefaultMeldPrioError: (state) => {
            state.loadDefaultMeldPrioError = undefined
        },
        resetloadDefaultMeldStatus: (state) => {
            state.defaultMeldStatus = undefined
            state.loadDefaultMeldStatusError = undefined
        },
        resetloadDefaultMeldStatusError: (state) => {
            state.loadDefaultMeldStatusError = undefined
        },
        resetloadDefaultMeldungsart: (state) => {
            state.defaultMeldungsart = undefined
            state.loadDefaultMeldungsartError = undefined
        },
        resetloadDefaultMeldungsartError: (state) => {
            state.loadDefaultMeldungsartError = undefined
        },
        resetsetMeldungStatus: (state) => {
            state.formItem = undefined
            state.setMeldungStatusError = undefined
        },
        resetsetMeldungStatusError: (state) => {
            state.setMeldungStatusError = undefined
        },
        removeFromMeldungListById: (state, action) => {
            state.meldungList = state.meldungList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromMeldungListByIds: (state, action) => {
            state.meldungList = state.meldungList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.meldungList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.loadMeldungListStatus = 'preloaded'
            state.loadMeldungListLastArgs = ''
        },
        clearPreloadedData: (state) => {
            state.meldungList = []
            state.loadMeldungListStatus = 'idle'
            state.loadMeldungListLastArgs = undefined
        },
    },
    extraReducers: builder => {
        builder.addCase(loadMeldungList.pending, (state) => {
            state.loadMeldungListStatus = 'pending'
            state.loadMeldungListError = undefined
        })
        builder.addCase(loadMeldungList.fulfilled, (state, action) => {
            state.loadMeldungListStatus = 'idle'

            if (!action.payload) { return }

            state.loadMeldungListLastArgs = action.payload.args

            {
                state.meldungList = action.payload.data

            }
        })
        builder.addCase(loadMeldungList.rejected, (state, action) => {
            state.loadMeldungListStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadMeldungListError = action.error.message
            } else {
                state.loadMeldungListError = action.payload
            }
        })

        builder.addCase(loadMeldung.pending, (state) => {
            state.loadMeldungStatus = 'pending'
            state.loadMeldungError = undefined
        })
        builder.addCase(loadMeldung.fulfilled, (state, action) => {
            state.loadMeldungStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.meldungList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.meldungList.push(newItem) }
                else { state.meldungList[i] = { ...state.meldungList[i], ...newItem } }
            }
        })
        builder.addCase(loadMeldung.rejected, (state, action) => {
            state.loadMeldungStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadMeldungError = action.error.message
            } else {
                state.loadMeldungError = action.payload
            }
        })

        builder.addCase(saveMeldung.pending, (state) => {
            state.saveMeldungStatus = 'pending'
            state.saveMeldungError = undefined
        })
        builder.addCase(saveMeldung.fulfilled, (state, action) => {
            state.saveMeldungStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.meldungList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.meldungList.push(newItem) }
                else { state.meldungList[i] = { ...state.meldungList[i], ...newItem } }
            }
        })
        builder.addCase(saveMeldung.rejected, (state, action) => {
            state.saveMeldungStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.saveMeldungError = action.error.message
            } else {
                state.saveMeldungError = action.payload
            }
        })

        builder.addCase(deleteMeldungen.pending, (state) => {
            state.deleteMeldungenStatus = 'pending'
            state.deleteMeldungenError = undefined
        })
        builder.addCase(deleteMeldungen.fulfilled, (state, action) => {
            state.deleteMeldungenStatus = 'idle'

            {
                if (Array.isArray(action.payload.data)) {
                    state.meldungList = state.meldungList.filter((x: any) => !action.payload.data.includes(x.HDR_ID))
                } else {
                    state.meldungList = state.meldungList.filter((x: any) => x.HDR_ID !== action.payload.data)
                }
            }
        })
        builder.addCase(deleteMeldungen.rejected, (state, action) => {
            state.deleteMeldungenStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.deleteMeldungenError = action.error.message
            } else {
                state.deleteMeldungenError = action.payload
            }
        })

        builder.addCase(loadDefaultMeldPrio.pending, (state) => {
            state.loadDefaultMeldPrioStatus = 'pending'
            state.loadDefaultMeldPrioError = undefined
        })
        builder.addCase(loadDefaultMeldPrio.fulfilled, (state, action) => {
            state.loadDefaultMeldPrioStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.defaultMeldPrio = newItem
            }
        })
        builder.addCase(loadDefaultMeldPrio.rejected, (state, action) => {
            state.loadDefaultMeldPrioStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadDefaultMeldPrioError = action.error.message
            } else {
                state.loadDefaultMeldPrioError = action.payload
            }
        })

        builder.addCase(loadDefaultMeldStatus.pending, (state) => {
            state.loadDefaultMeldStatusStatus = 'pending'
            state.loadDefaultMeldStatusError = undefined
        })
        builder.addCase(loadDefaultMeldStatus.fulfilled, (state, action) => {
            state.loadDefaultMeldStatusStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.defaultMeldStatus = newItem
            }
        })
        builder.addCase(loadDefaultMeldStatus.rejected, (state, action) => {
            state.loadDefaultMeldStatusStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadDefaultMeldStatusError = action.error.message
            } else {
                state.loadDefaultMeldStatusError = action.payload
            }
        })

        builder.addCase(loadDefaultMeldungsart.pending, (state) => {
            state.loadDefaultMeldungsartStatus = 'pending'
            state.loadDefaultMeldungsartError = undefined
        })
        builder.addCase(loadDefaultMeldungsart.fulfilled, (state, action) => {
            state.loadDefaultMeldungsartStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.defaultMeldungsart = newItem
            }
        })
        builder.addCase(loadDefaultMeldungsart.rejected, (state, action) => {
            state.loadDefaultMeldungsartStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadDefaultMeldungsartError = action.error.message
            } else {
                state.loadDefaultMeldungsartError = action.payload
            }
        })

        builder.addCase(setMeldungStatus.pending, (state) => {
            state.setMeldungStatusStatus = 'pending'
            state.setMeldungStatusError = undefined
        })
        builder.addCase(setMeldungStatus.fulfilled, (state, action) => {
            state.setMeldungStatusStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.meldungList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.meldungList.push(newItem) }
                else { state.meldungList[i] = { ...state.meldungList[i], ...newItem } }
            }
        })
        builder.addCase(setMeldungStatus.rejected, (state, action) => {
            state.setMeldungStatusStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.setMeldungStatusError = action.error.message
            } else {
                state.setMeldungStatusError = action.payload
            }
        })

    }
})

export const {
    resetloadMeldungListError,
    resetloadMeldung,
    resetloadMeldungError,
    resetsaveMeldung,
    resetsaveMeldungError,
    resetdeleteMeldungenError,
    resetloadDefaultMeldPrio,
    resetloadDefaultMeldPrioError,
    resetloadDefaultMeldStatus,
    resetloadDefaultMeldStatusError,
    resetloadDefaultMeldungsart,
    resetloadDefaultMeldungsartError,
    resetsetMeldungStatus,
    resetsetMeldungStatusError,
    removeFromMeldungListById,
    removeFromMeldungListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = MeldungSlice.actions
export default MeldungSlice.reducer
